import styled from "styled-components";
import { BASIC_BLACK } from "../../../constants/colors";
import { Button } from "../../atoms/Button";

type Props = {
  name: string;
  onSelect: () => void;
};

export const FavoriteStoreSelectItem: React.FC<Props> = ({
  name,
  onSelect,
}) => {
  return (
    <FavoriteStoreSelectItemContainer>
      <FavoriteStoreName>{name}</FavoriteStoreName>
      <Button
        btnStyle="primary"
        customSize={{ width: "132px", height: "54px" }}
        text="選択"
        onClick={onSelect}
        rounded="md"
      />
    </FavoriteStoreSelectItemContainer>
  );
};

const FavoriteStoreSelectItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  button {
    font-weight: 600;
  }
`;

const FavoriteStoreName = styled.div`
  flex: 1;
  padding: 0;
  margin: 0;
  font-size: 20px;
  color: ${BASIC_BLACK};
  font-weight: 600;
  text-align: left;
`;
